module.exports = __webpack_public_path__ + "static/media/gray-drop.243136ca.svg";